var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "KeepAlive",
          [
            _c("CreditCardStripe", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectedProvider === "stripe",
                  expression: "selectedProvider === 'stripe'",
                },
              ],
              ref: "stripeCreditCard",
              attrs: {
                disabled: _vm.disabled,
                "stripe-payment-intent": _vm.stripePaymentIntent,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }